import { createStyles } from "@mantine/core";

export const useStyles = createStyles(() => ({
  filterButton: {
    "@media (max-width: 48em)": {
      width: "100%",
    },
  },
}));
